<template>
  <div class="changepassword">
    <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
      <FormItem label="账号" prop="Accountnumber">
        <Input type="text" v-model="formCustom.Accountnumber"></Input>
      </FormItem>
      <FormItem label="原密码" prop="Oldpasswd">
        <Input type="password" v-model="formCustom.Oldpasswd"></Input>
      </FormItem>
      <FormItem label="新密码" prop="Newpasswd">
        <Input type="password" v-model="formCustom.Newpasswd"></Input>
      </FormItem>
      <FormItem label="确认密码" prop="passwdCheck">
        <Input type="password" v-model="formCustom.passwdCheck"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('formCustom')">提交</Button>
        <Button @click="handleReset('formCustom')" style="margin-left: 8px">返回</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { Changepassword } from '../../../api/login'
export default {
  name: 'changepassword',
  data () {
    const validateAccountnumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入你的账号'))
      } else {
        callback()
      }
    }
    const validateOldPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入你的原密码'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入你的新密码'))
      } else {
        if (this.formCustom.passwdCheck !== '') {
          // 对第二个密码框单独验证
          this.$refs.formCustom.validateField('passwdCheck')
        }
        callback()
      }
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入你的新密码'))
      } else if (value !== this.formCustom.Newpasswd) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    // const validateAge = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('Age cannot be empty'))
    //   }
    //   // 模拟异步验证效果
    //   setTimeout(() => {
    //     if (!Number.isInteger(value)) {
    //       callback(new Error('Please enter a numeric value'))
    //     } else {
    //       if (value < 18) {
    //         callback(new Error('Must be over 18 years of age'))
    //       } else {
    //         callback()
    //       }
    //     }
    //   }, 1000)
    // }

    return {
      formCustom: {
        Accountnumber: '',
        Oldpasswd: '',
        Newpasswd: '',
        passwdCheck: ''
      },
      ruleCustom: {
        Accountnumber: [{ validator: validateAccountnumber, trigger: 'blur' }],
        Oldpasswd: [{ validator: validateOldPass, trigger: 'blur' }],
        Newpasswd: [{ validator: validatePass, trigger: 'blur' }],
        passwdCheck: [{ validator: validatePassCheck, trigger: 'blur' }]
        // age: [{ validator: validateAge, trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          Changepassword({
            NewPassword: this.formCustom.Newpasswd,
            User: this.formCustom.Accountnumber,
            Password: this.formCustom.Oldpasswd
          }).then((res) => {
            if (res.isSuccess) {
              this.$Message['success']({
                background: true,
                content: '修改成功'
              })
            } else {
              this.$Message['error']({
                background: true,
                content: res.message
              })
            }
          })
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    handleReset (name) {
      // this.$refs[name].resetFields()
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.changepassword{
  margin: 1rem;
  width: 22rem;
  height: 100%;
}
</style>>
